module.exports = __webpack_public_path__ + "img/CM-SL-CA-Kia-Established-1.31cb88b0.jpg";